var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-box" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "button",
          { staticClass: "menu-button", on: { click: _vm.toggleMenuDisplay } },
          [_c("van-icon", { attrs: { name: "ellipsis" } })],
          1
        ),
        _c("h1", { staticClass: "page-title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("div", { staticClass: "right-space" }, [_vm._t("right-space")], 2),
      ]),
      _c(
        "van-popup",
        {
          staticClass: "popup-menu",
          attrs: { position: "left" },
          model: {
            value: _vm.showMenu,
            callback: function ($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu",
          },
        },
        [
          _c(
            "van-sidebar",
            {
              staticClass: "menu-list",
              on: { change: _vm.handleNaviItemSelected },
              model: {
                value: _vm.activeMenu,
                callback: function ($$v) {
                  _vm.activeMenu = $$v
                },
                expression: "activeMenu",
              },
            },
            _vm._l(_vm.menuList, function (item, index) {
              return _c("van-sidebar-item", {
                key: index,
                attrs: { title: item.title },
              })
            }),
            1
          ),
          _c(
            "van-button",
            {
              staticClass: "logout",
              attrs: { type: "default" },
              on: { click: _vm.logout },
            },
            [_vm._v("退出登录")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }